import { Transition, TransitionChild } from '@headlessui/react';
import { Fragment, ReactNode } from 'react';

const ImagePreviewBar = ({
    visible,
    children,
}: {
    visible: boolean;
    children: ReactNode;
}) => (
    <div className="h-13 w-full flex-0">
        <Transition show={visible} as={Fragment}>
            <TransitionChild
                as="div"
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="h-13 w-full bg-black/40">{children}</div>
            </TransitionChild>
        </Transition>
    </div>
);

export default ImagePreviewBar;
